import styled from 'styled-components';

export default styled.div`
  font-size: 1.1rem;
`;
